'use client';
import { twMerge } from 'tailwind-merge';
import Logo from '../ui/Logo';
import IconButton from '../ui/IconButton';
import Link from 'next/link';


interface FooterProps {
  className?: string;
}

const Footer = ({ className }: FooterProps) => {
  const socialLinks = [
    {
      src: '/images/X-Twitter.svg',
      alt: 'X-Twitter',
      href: 'https://x.com/Blockverseries',
      width: '24',
      height: '24',
    },
    {
      src: '/images/instagram-logo-fill.svg',
      alt: 'instagram',
      href: '#',
      width: '24',
      height: '24',
    },
    {
      src: '/images/telegram.svg',
      alt: 'Telegram',
      href: 'http://t.me/blockverseseries',
      width: '24',
      height: '24',
    },
    {
      src: '/images/mail-footer-icon.svg',
      alt: 'mail-footer-icon',
      href: 'mailto:collab@blockverseseries.com',
      width: '24',
      height: '24',
      link: 'mailto:collab@blockverseseries.com'

    },
  ];

  return (
    <footer data-component-id="src/components/common/Footer.tsx:47:4" data-component-path="src/components/common/Footer.tsx" data-component-line="47" data-component-end-line="85" data-component-file="Footer.tsx" data-component-name="footer" data-component-content="%7B%22elementName%22%3A%22footer%22%7D" className={twMerge('w-full bg-white', className)}>
      <div data-component-id="src/components/common/Footer.tsx:48:6" data-component-path="src/components/common/Footer.tsx" data-component-line="48" data-component-end-line="84" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
        className={twMerge(
          'w-full max-w-[1300px] mx-auto',
          'mt-10',
          'bg-[#2D0077]',
          'px-4 sm:px-6 lg:px-[120px]',
          'py-6 sm:py-8 md:py-10',
          'rounded-t-[28px]',
          'flex flex-col sm:flex-row justify-between items-center gap-6 sm:gap-0'
        )}
      >
        {/* Logo */}
        <Link data-component-id="src/components/common/Footer.tsx:60:8" data-component-path="src/components/common/Footer.tsx" data-component-line="60" data-component-end-line="66" data-component-file="Footer.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2F%22%7D" href='/'>
        <Logo data-component-id="src/components/common/Footer.tsx:61:8" data-component-path="src/components/common/Footer.tsx" data-component-line="61" data-component-end-line="65" data-component-file="Footer.tsx" data-component-name="Logo" data-component-content="%7B%22elementName%22%3A%22Logo%22%2C%22src%22%3A%22%2Fimages%2Fblockver-series-footer.svg%22%2C%22alt%22%3A%22Blockverse-Series-Footer-Logo%22%7D"
          src="/images/blockver-series-footer.svg"
          alt="Blockverse-Series-Footer-Logo"
          variant="footer"
        />
        </Link>
        {/* Social Icons */}
        <div data-component-id="src/components/common/Footer.tsx:68:8" data-component-path="src/components/common/Footer.tsx" data-component-line="68" data-component-end-line="83" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-4%20sm%3Agap-6%20md%3Agap-8%22%7D" className="flex gap-4 sm:gap-6 md:gap-8">
          {socialLinks.map((social, index) => (
            <IconButton data-component-id="src/components/common/Footer.tsx:70:12" data-component-path="src/components/common/Footer.tsx" data-component-line="70" data-component-end-line="81" data-component-file="Footer.tsx" data-component-name="IconButton" data-component-content="%7B%22elementName%22%3A%22IconButton%22%2C%22className%22%3A%22hover%3Ascale-110%20transition-transform%20duration-200%20hover%3Abg-%5B%236e34ea8a%5D%22%7D"
              key={index}
              src={social.src}
              alt={social.alt}
              width={social.width}
              height={social.height}
              variant="transparent"
              size="medium"
              className="hover:scale-110 transition-transform duration-200 hover:bg-[#6e34ea8a]"
              onClick={() => window.open(social.href, '_blank')}
              rel="noopener noreferrer nofollow"
            />
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
